/**
 * Last chart / New Order symbol chosen in the trading shell.
 * History Balance sheet reads this so Chart / New Order can fall back correctly.
 */

let _symbol = "";
let _row = null;
const listeners = new Set();

export function setLastChartSelection(symbol, row = null) {
  _symbol = String(symbol || "").trim();
  _row = row && typeof row === "object" ? row : null;
  const snap = { symbol: _symbol, row: _row };
  listeners.forEach((fn) => {
    try {
      fn(snap);
    } catch {
      /* ignore subscriber errors */
    }
  });
}

export function getLastChartSelection() {
  return { symbol: _symbol, row: _row };
}

export function subscribeLastChartSelection(fn) {
  if (typeof fn !== "function") return () => {};
  listeners.add(fn);
  return () => listeners.delete(fn);
}
